const initialState = {
  showLoader: false,
  showContact: false,
  timeout: 10000
}

function reduceLoader(state = initialState, action) {
  let nextState
  switch (action.type) {
    case 'SHOW_LOADER':
      nextState = {
        ...state,
        showLoader: true,
        timeout: action.timeout || 10000
      }
      return nextState || state
    case 'HIDE_LOADER':
      nextState = {
        ...state,
        showLoader: false
      }
      return nextState || state
    case 'SHOW_CONTACT':
      nextState = {
        ...state,
        showContact: true
      }
      return nextState || state
    case 'HIDE_CONTACT':
      nextState = {
        ...state,
        showContact: false
      }
      return nextState || state
    default:
      return state
  }
}

export default reduceLoader